// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getNavigationEditDetails, getNavigationCollections, putNavigationFormData } from '@/services/decoration.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getNavigationCollections().then(res => {
        if (res.status === 200) {
          this.formData[0].createDateItem[6].options = res.data.models
          this.formData[0].createDateItem[1].options = res.data.navigation_types
        }
      })
      getNavigationEditDetails(this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.modifyData = res.data.navigation_button
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        navigation_button: obj
      }
      Object.keys(params.navigation_button).forEach(res => {
        if (typeof params.navigation_button[res] === 'boolean') {
          if (params.navigation_button[res] === true) params.navigation_button[res] = '1'
          if (params.navigation_button[res] === false) params.navigation_button[res] = '0'
        }
      })
      putNavigationFormData(params, this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'navigationList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
